module.exports = "https://coursera_assets.s3.amazonaws.com/images/5a19f55d37f221924b5e2d1e1d122031.png";